var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 12H21.375M18.0938 5.90625L19.0312 4.96875M12 3.5625V2.625M5.90625 5.90625L4.96875 4.96875M3.5625 12H2.625M10.125 21.375H13.875M16.6875 12C16.6873 11.1549 16.4586 10.3257 16.0257 9.59994C15.5927 8.8742 14.9717 8.27899 14.2282 7.87729C13.4847 7.4756 12.6465 7.28235 11.8022 7.31801C10.9579 7.35367 10.1389 7.6169 9.43199 8.07986C8.72504 8.54281 8.15638 9.18827 7.78619 9.94792C7.41601 10.7076 7.25807 11.5532 7.32908 12.3952C7.40009 13.2373 7.69742 14.0445 8.1896 14.7314C8.68177 15.4184 9.3505 15.9595 10.125 16.2975V18.5625H13.875V16.2975C14.7111 15.9325 15.4225 15.3315 15.9221 14.5681C16.4216 13.8048 16.6876 12.9123 16.6875 12Z",
    stroke: "url(#paint0_linear_1637_4769)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1637_4769",
    x1: 12,
    y1: 2.625,
    x2: 12,
    y2: 21.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90B3E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotIcon1);
export default __webpack_public_path__ + "static/media/spotIcon1.1e3fba7d496437f00eea7d5468ece1e5.svg";
export { ForwardRef as ReactComponent };